import React, { FC } from 'react'

import { FORM_ELEMENTS } from '../types'

import * as SC from './styled'

export type SectionTitleProps = {
  className?: string
  type?: FORM_ELEMENTS.SECTION_TITLE
  title?: string
  name?: string
}

const SectionTitle: FC<SectionTitleProps> = (props) => {
  const { title, className } = props

  return <SC.Title className={className}>{title}</SC.Title>
}

export default SectionTitle
